import { z } from "zod";

export const caseStudySchema = z.object({
  title: z.string(),
  patientInfo: z.object({
    name: z.string(),
    age: z.number(),
    position: z.string(),
    conditions: z.array(z.string()),
  }),
  objectives: z.array(z.string()),
  scenario: z.object({
    description: z.string()
  }),
  keyPoints: z.array(z.string()),
});

export default caseStudySchema;
